/**
 * Plugin Prerender.io pour Vue 3
 * Signale à Prerender.io quand la page est complètement chargée
 */

export default {
  install(app) {
    // Détecte si on est en mode prerender (crawler bot)
    const isPrerendering = window.navigator.userAgent.toLowerCase().indexOf('prerender') !== -1;

    if (isPrerendering) {
      console.log('[Prerender.io] Bot détecté - Mode pré-rendu activé');
    }

    // Fonction pour signaler que la page est prête
    const signalPageReady = () => {
      if (typeof window !== 'undefined') {
        // Signal à Prerender.io que la page est prête
        window.prerenderReady = true;

        if (isPrerendering) {
          console.log('[Prerender.io] Page marquée comme prête');
        }
      }
    };

    // Ajouter une méthode globale accessible partout dans l'app
    app.config.globalProperties.$prerenderReady = signalPageReady;

    // Auto-signaler après le montage de l'app (fallback)
    app.mixin({
      mounted() {
        // Attendre que le contenu soit chargé
        this.$nextTick(() => {
          // Délai pour laisser le temps aux données async de se charger
          setTimeout(() => {
            if (!window.prerenderReady) {
              signalPageReady();
            }
          }, 2000);
        });
      }
    });
  }
};
